import { type FC, type ReactNode } from "react";
import cx from "classnames";

import styles from "./LoadingText.module.css";
import { useI18n } from "../../i18n";

type Props = {
  text?: string;
  className?: string;
  children?: ReactNode;
};

export const LoadingText: FC<Props> = ({
  text,
  className,
  children,
}) => {
  const i18n = useI18n();
  const resolvedText = text ?? i18n.loadingText.thinking;
  return (
    <span
      className={cx(styles.root, className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {children ?? resolvedText}
    </span>
  );
};
